import _defineProperty from "/home/runner/work/documentation/documentation/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { system } from 'styled-system';
import { COMMON, TYPOGRAPHY, get } from './constants';
import sx from './sx';
import theme from './theme';
var buttonStyles = "\n  display: inline-block;\n  padding: 0;\n  font-size: inherit;\n  white-space: nowrap;\n  cursor: pointer;\n  user-select: none;\n  background-color: transparent;\n  border: 0;\n  appearance: none;\n";
var hoverColor = system({
  hoverColor: {
    property: 'color',
    scale: 'colors'
  }
});
var Link = styled.a.withConfig({
  displayName: "Link",
  componentId: "sc-1brdqhf-0"
})(["color:", ";text-decoration:", ";&:hover{text-decoration:", ";", ";}&:is(button){display:inline-block;padding:0;font-size:inherit;white-space:nowrap;cursor:pointer;user-select:none;background-color:transparent;border:0;appearance:none;}", ";", ";", ";"], function (props) {
  return props.muted ? get('colors.gray.6')(props) : get('colors.blue.5')(props);
}, function (props) {
  return props.underline ? 'underline' : 'none';
}, function (props) {
  return props.muted ? 'none' : 'underline';
}, function (props) {
  return props.hoverColor ? hoverColor : props.muted ? "color: ".concat(get('colors.blue.5')(props)) : '';
}, TYPOGRAPHY, COMMON, sx);
Link.defaultProps = {
  theme: theme
};
Link.propTypes = _objectSpread(_objectSpread(_objectSpread({
  hoverColor: PropTypes.string,
  href: PropTypes.string,
  muted: PropTypes.bool,
  theme: PropTypes.object,
  underline: PropTypes.bool
}, TYPOGRAPHY.propTypes), COMMON.propTypes), sx.propTypes);
export default Link;